import { Route } from '@angular/router';

export const PrescriptionReportRoute: Route = {
  path: 'prescriptions-report',
  loadComponent() {
    return import('@daas-consulting/production/shared/frontend/pages').then(
      (c) => c.LayoutBase2PageComponent
    );
  },
  loadChildren() {
    return import(
      '@daas-consulting/production/shared/frontend/prescription_report_shell'
    ).then((c) => c.prescriptionReportShellRoutes);
  },
};

export const PrescriptionReportDetailRedirectRoute: Route = {
  path: 'bags-report/detail',
  redirectTo: 'prescriptions-report/detail',
  pathMatch: 'full',
};

export const PrescriptionReportSummaryRedirectRoute: Route = {
  path: 'bags-report/summary',
  redirectTo: 'prescriptions-report/summary',
  pathMatch: 'full',
};
